export interface RichTextFontOption {
    value: string;
    label: string;
    icon: string;
    utilityClass: string;
    quillValue?: string;
}

export interface RichTextPresetOption {
    value: string;
    label: string;
    icon: string;
    classes: string[];
}

export interface RichTextAlignOption {
    value: "left" | "center" | "right";
    label: string;
    icon: string;
    className: "--tal" | "--tac" | "--tar";
}

export const RICH_TEXT_FONT_OPTIONS: RichTextFontOption[] = [
    { value: "default", label: "Normal", icon: "fa-solid fa-font", utilityClass: "" },
    { value: "serif", label: "Serif", icon: "fa-solid fa-font", utilityClass: "--font-serif", quillValue: "serif" },
    { value: "monospace", label: "Mono", icon: "fa-solid fa-terminal", utilityClass: "--font-mono", quillValue: "monospace" },
    { value: "display", label: "Display", icon: "fa-solid fa-heading", utilityClass: "--font-display", quillValue: "display" },
    { value: "pretendard", label: "Pretendard", icon: "fa-solid fa-language", utilityClass: "--font-pretendard", quillValue: "pretendard" },
    { value: "inter", label: "Inter", icon: "fa-solid fa-font", utilityClass: "--font-inter", quillValue: "inter" },
    { value: "noto", label: "Noto KR", icon: "fa-solid fa-language", utilityClass: "--font-noto", quillValue: "noto" },
    { value: "nanum", label: "Nanum", icon: "fa-solid fa-language", utilityClass: "--font-nanum", quillValue: "nanum" },
    { value: "cormorant", label: "Cormorant", icon: "fa-solid fa-feather", utilityClass: "--font-cormorant", quillValue: "cormorant" },
    { value: "rounded", label: "Rounded", icon: "fa-solid fa-circle", utilityClass: "--font-rounded", quillValue: "rounded" },
];

export const RICH_TEXT_PRESET_OPTIONS: RichTextPresetOption[] = [
    { value: "display-xl", label: "Display 1", icon: "fa-solid fa-display", classes: ["no-display-xl", "--fw-700"] },
    { value: "display-lg", label: "Display 2", icon: "fa-solid fa-display", classes: ["no-display-lg", "--fw-700"] },
    { value: "display-md", label: "Display 3", icon: "fa-solid fa-display", classes: ["no-display-md", "--fw-700"] },
    { value: "display-sm", label: "Display 4", icon: "fa-solid fa-display", classes: ["no-display-sm", "--fw-700"] },
    { value: "display-xs", label: "Display 5", icon: "fa-solid fa-display", classes: ["no-display-xs", "--fw-700"] },
    { value: "heading-xl", label: "Heading 1", icon: "fa-solid fa-heading", classes: ["no-heading-xl", "--fw-700"] },
    { value: "heading-lg", label: "Heading 2", icon: "fa-solid fa-heading", classes: ["no-heading-lg", "--fw-700"] },
    { value: "heading-md", label: "Heading 3", icon: "fa-solid fa-heading", classes: ["no-heading-md", "--fw-700"] },
    { value: "heading-sm", label: "Heading 4", icon: "fa-solid fa-heading", classes: ["no-heading-sm", "--fw-700"] },
    { value: "heading-xs", label: "Heading 5", icon: "fa-solid fa-heading", classes: ["no-heading-xs", "--fw-700"] },
    { value: "body-xl", label: "Body 1", icon: "fa-solid fa-paragraph", classes: ["no-body-xl", "--fw-400"] },
    { value: "body-lg", label: "Body 2", icon: "fa-solid fa-paragraph", classes: ["no-body-lg", "--fw-400"] },
    { value: "body-md", label: "Body 3", icon: "fa-solid fa-paragraph", classes: ["no-body-md", "--fw-400"] },
    { value: "body-sm", label: "Body 4", icon: "fa-solid fa-paragraph", classes: ["no-body-sm", "--fw-400"] },
    { value: "body-xs", label: "Body 5", icon: "fa-solid fa-paragraph", classes: ["no-body-xs", "--fw-400"] },
];

export const RICH_TEXT_ALIGN_OPTIONS: RichTextAlignOption[] = [
    { value: "left", label: "Left", icon: "fa-solid fa-align-left", className: "--tal" },
    { value: "center", label: "Center", icon: "fa-solid fa-align-center", className: "--tac" },
    { value: "right", label: "Right", icon: "fa-solid fa-align-right", className: "--tar" },
];

export const RICH_TEXT_INLINE_CLASS_PATTERNS = [
    /^no-(display|heading|body)-[a-z0-9-]+$/i,
    /^--fw-[0-9]+$/i,
    /^--text-[a-z0-9-]+$/i,
    /^--font-[a-z0-9-]+$/i,
];

export function richTextFontOptionsForQuill(): string[] {
    return RICH_TEXT_FONT_OPTIONS
        .map((option) => option.quillValue)
        .filter((value): value is string => typeof value === "string" && value !== "");
}

export function richTextOptionMap<T extends { value: string; label: string }>(items: T[]): Record<string, string> {
    return items.reduce<Record<string, string>>((carry, item) => {
        carry[item.value] = item.label;
        return carry;
    }, {});
}
